import "./tech-section-header.css";

export default function TechSectionHeader({
  eyebrow = "OUR SERVICES",
  title,
  highlight,
  subtitle,
  align = "center",
  dark = false,
}) {
  return (
    <div
      className={`oglitz-section-header oglitz-section-header--${align}  ${
        dark ? "oglitz-section-header--dark" : ""
      }`}
    >
      <span className="oglitz-section-header__eyebrow">{eyebrow}</span>

      <h2 className="oglitz-section-header__title">
        {title} {highlight && <span>{highlight}</span>}
      </h2>

      {subtitle && (
        <p className="oglitz-section-header__subtitle">{subtitle}</p>
      )}
    </div>
  );
}
